import React, { FC } from "react";
import Image from "next/image";
import getConfig from "next/config";
import { ExternalLink } from "../../links/ExternalLink";
import { getCloudflareLoader } from "../../../helpers/cloudflareImages";
import { FooterIconSvg } from "../common/icons";
import { Device } from "../../../styles/screenSizes";
import {
  StyledBranding,
  StyledBrandLogo,
  StyledBrandLogoImg,
  StyledPhoneAndAddress,
  StyledSocialMediaIcons,
} from "./index.styled";

const { publicRuntimeConfig } = getConfig();

export interface FooterBranding {
  logoImgLink?: string;
  phoneNumber?: string;
  addressLine1?: string;
  addressLine2?: string;
}

export interface FooterBrandingProps extends FooterBranding {
  instagramLink?: string;
  facebookLink?: string;
  twitterLink?: string;
  pinterestLink?: string;
  linkedInLink?: string;
  youtubeLink?: string;
}

export const Branding: FC<FooterBrandingProps> = ({
  logoImgLink,
  instagramLink,
  facebookLink,
  twitterLink,
  pinterestLink,
  linkedInLink,
  youtubeLink,
  phoneNumber,
  addressLine1,
  addressLine2,
}) => {
  const hasSocialMedia =
    !!instagramLink ||
    !!facebookLink ||
    !!twitterLink ||
    !!pinterestLink ||
    !!linkedInLink ||
    !!youtubeLink;

  return (
    <StyledBranding data-testid="footer-branding">
      <StyledBrandLogoImg>
        {!!logoImgLink && (
          <Image
            src={logoImgLink}
            alt="Brand logo"
            loader={getCloudflareLoader(publicRuntimeConfig.cdn)}
            fill
            sizes={`${Device.mobile} 50vw, ${Device.tablet} 33vw, ${Device.laptop} 25vw`}
            style={{
              objectFit: "contain",
            }}
          />
        )}
      </StyledBrandLogoImg>
      {hasSocialMedia && (
        <StyledSocialMediaIcons>
          {!!instagramLink && (
            <ExternalLink href={instagramLink}>
              <StyledBrandLogo>{FooterIconSvg.instagram}</StyledBrandLogo>
            </ExternalLink>
          )}
          {!!facebookLink && (
            <ExternalLink href={facebookLink}>
              <StyledBrandLogo>{FooterIconSvg.facebook}</StyledBrandLogo>
            </ExternalLink>
          )}
          {!!twitterLink && (
            <ExternalLink href={twitterLink}>
              <StyledBrandLogo>{FooterIconSvg.twitter}</StyledBrandLogo>
            </ExternalLink>
          )}
          {!!pinterestLink && (
            <ExternalLink href={pinterestLink}>
              <StyledBrandLogo>{FooterIconSvg.pinterest}</StyledBrandLogo>
            </ExternalLink>
          )}
          {!!linkedInLink && (
            <ExternalLink href={linkedInLink}>
              <StyledBrandLogo>{FooterIconSvg.linkedIn}</StyledBrandLogo>
            </ExternalLink>
          )}
          {!!youtubeLink && (
            <ExternalLink href={youtubeLink}>
              <StyledBrandLogo>{FooterIconSvg.youtube}</StyledBrandLogo>
            </ExternalLink>
          )}
        </StyledSocialMediaIcons>
      )}
      <StyledPhoneAndAddress>
        {!!phoneNumber && <p>{phoneNumber}</p>}
        {!!addressLine1 && <p>{addressLine1}</p>}
        {!!addressLine2 && <p>{addressLine2}</p>}
      </StyledPhoneAndAddress>
    </StyledBranding>
  );
};
